<template>
  <div class="home">
    <cmp-header></cmp-header>

    <nav-header ref="nav_header"></nav-header>
    <about-pn></about-pn>
    <star-product></star-product>
    <company-news></company-news>
    <cooperate></cooperate>
    <business></business>

    <!-- <about-pn class="left-css" :class="{ active2: isActive1 }"></about-pn>
    <star-product
      class="right-css"
      :class="{ active1: isActive2 }"
    ></star-product>
    <company-news
      class="left-css"
      :class="{ active2: isActive3 }"
    ></company-news>
    <cooperate class="right-css" :class="{ active1: isActive4 }"></cooperate>
    <business class="left-css" :class="{ active2: isActive4 }"></business> -->
    <Footer></Footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Home',
  data() {
    return {
      isActive1: false,
      isActive2: false,
      isActive3: false,
      isActive4: false,
      isActive5: false,
      index: 0
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions(['GetHome', 'GetIndex']),
    init() {
      this.$nextTick(() => {
        this.GetHome().then(res => {})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.left-css {
  opacity: 0;
  transform: translate(-200px, 0px);
  transition: all 1s ease;
}
.right-css {
  opacity: 0;
  transform: translate(-180px, 200px);
  transition: all 1s ease;
}
.active1 {
  transform: translate(0px, 0px);
  opacity: 1;
}
.active2 {
  opacity: 1;
  transform: translate(0px, 0px);
}
</style>
